import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { SearchField } from './SearchField';
import { SearchResults } from './SearchResults';
import { useApp } from './AppContext';
import type { Screen } from '../App';
import type { Question } from './AppContext';

interface SearchScreenProps {
  onNavigate: (screen: Screen) => void;
  onBack: () => void;
}

export const SearchScreen: React.FC<SearchScreenProps> = ({ onNavigate, onBack }) => {
  const { getBackgroundClass } = useApp();
  const [searchResults, setSearchResults] = useState<Question[]>([]);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchResults = (results: Question[], query: string) => {
    setSearchResults(results);
    setSearchQuery(query);
  };

  return (
    <div className={`screen-min-h-full ${getBackgroundClass()} max-w-full lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl mx-auto flex flex-col`}>
      {/* Fixed Header with back button and search field */}
      <div className="app-header-fixed">
        <div className="flex items-center gap-3 sm:gap-4 h-full">
          <button
            onClick={onBack}
            className="arrow-button"
            aria-label="Назад"
          >
            <ArrowLeft className="arrow-icon" />
          </button>
          
          {/* Search input integrated in header */}
          <div className="flex-1">
            <SearchField 
              onNavigate={onNavigate} 
              onQuestionSelect={() => {}} // No longer needed
              showOverlay={false}
              onSearchResults={handleSearchResults}
            />
          </div>
        </div>
      </div>

      {/* Scrollable content area for search results */}
      <div className="app-content-scrollable">
        <SearchResults 
          results={searchResults}
          query={searchQuery}
          onQuestionSelect={() => {}} // No longer needed
          onNavigate={onNavigate}
        />
      </div>
    </div>
  );
};